import {observer} from "mobx-react"
import {PathTracking} from "dto/path-tracking/path-tracking"
import {useFindPathTrackingAll} from "hooks/queries/path-tracking.query"
import {
    GridTableColumn,
    GridTableHeaderWrapper,
    GridTableListItemWrapper
} from "pages/admin/common/common-style-component"
import dayjs from "dayjs"
import {Pagination} from "common/Pagination"
import {SensorStatus} from "dto/realdevice/devices"
import {SensorStatusTag} from "pages/dashboard/wheelchair/WheelchairListItems"

export const PathListView = observer(({
                                          page,
                                          size,
                                          setPage,
                                          selectedPath, selectPath,
                                      }: {
    selectedPath?: PathTracking | undefined,
    selectPath: (value: PathTracking) => void,
    page: number, size: number, setPage: (page: number) => void
}) => {

    const {data: pageable} = useFindPathTrackingAll()
    const trackingList = pageable?.content || []

    const numberOfElements = pageable?.totalElements || 0

    return (
        <>
            <GridTableHeaderWrapper gridTemplateColumns="5% auto 13% 13% 10% 10% 10% 20%" className="mt10"
            >
                <GridTableColumn>순번</GridTableColumn>
                <GridTableColumn>장비명(ID)</GridTableColumn>
                <GridTableColumn>위도</GridTableColumn>
                <GridTableColumn>경도</GridTableColumn>
                <GridTableColumn>기울기</GridTableColumn>
                <GridTableColumn>충격량</GridTableColumn>
                <GridTableColumn>배터리</GridTableColumn>
                <GridTableColumn>시간</GridTableColumn>
            </GridTableHeaderWrapper>
            {trackingList.map((path, idx) => {
                const rowNumber = ((page * size) + idx) + 1
                const date = dayjs(path.receivedAt).format("YYYY/MM/DD HH:mm:ss")
                const sensorStatus = path.sensorStatus || {} as SensorStatus
                return (
                    <>
                        <GridTableListItemWrapper
                            key={path.id} gridTemplateColumns="5% auto 13% 13% 10% 10% 10% 20%"
                            onClick={() => selectPath(path)}
                            style={{background: path.id === selectedPath?.id ? "#efefef" : ""}}
                        >
                            <GridTableColumn>
                                <span>{rowNumber}</span>
                            </GridTableColumn>
                            <GridTableColumn>{path.eui}</GridTableColumn>
                            <GridTableColumn>
                                <span className="tag has-background-success-light">{path.lat}</span>
                            </GridTableColumn>
                            <GridTableColumn>
                                <span className="tag has-background-success-light">{path.lng}</span>
                            </GridTableColumn>
                            <GridTableColumn>{path.gradient?.x}/{path.gradient?.y}</GridTableColumn>
                            <GridTableColumn>
                                {path.impact?.x}/{path.impact?.y}
                            </GridTableColumn>
                            <GridTableColumn>
                                {path?.battery?.level}
                            </GridTableColumn>
                            <GridTableColumn>
                                {date}
                            </GridTableColumn>
                        </GridTableListItemWrapper>
                        <GridTableListItemWrapper gridTemplateColumns={"auto"}>
                            <div className="columns mb-1 mt-1">
                                <div style={{marginLeft: "auto"}}/>
                                <SensorStatusTag sensorStatus={sensorStatus}/>
                                <div style={{marginRight: 30}}/>
                            </div>
                        </GridTableListItemWrapper>
                        {/*<div className="columns">*/}
                        {/*    <SensorStatusTag sensorStatus={sensorStatus}/>*/}
                        {/*</div>*/}
                    </>
                )
            })}
            <Pagination changePage={(page: number) => {
                setPage(page - 1)
            }} total={numberOfElements} size={size} page={page + 1}/>
        </>
    )
})
